// Провайдер server state (TanStack Query, app.md §4) + персист кэша кабинета на диск.
//
// `PersistQueryClientProvider` вместо голого `QueryClientProvider`: при старте он
// гидрирует кэш из снимка в Dexie (`shared/offline/queryPersist`), поэтому кабинет
// открывается с последними известными данными даже без сети и после перезапуска.
// Кухонные экраны в снимок не идут — у них свой кэш (T-036).

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { PropsWithChildren, ReactElement } from 'react';

import { queryClient } from '@/shared/api';
import { QUERY_SNAPSHOT_MAX_AGE_MS, queryPersister, shouldPersistQuery } from '@/shared/offline';

export function QueryProvider({ children }: PropsWithChildren): ReactElement {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: QUERY_SNAPSHOT_MAX_AGE_MS,
        dehydrateOptions: { shouldDehydrateQuery: shouldPersistQuery },
        // Смена версии приложения не должна выбрасывать снимок: контракт списков
        // кабинета стабилен, а на старте моноблока без сети снимок — единственные
        // данные. Несовместимую правку кэша закрывать бампом OFFLINE_DB_VERSION.
        buster: 'v1',
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
